import React, { Component } from 'react';
import { connect } from "react-redux";
import classnames from "classnames";
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";

import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Container } from 'reactstrap';
import Content from '../../components/Content/Content';

import * as actions from '../../actions/ApiActions';
import Headline from "../../components/Headline/Headline";

import styles from "./adminStyles.css";
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import FileUpload from '../../components/FileUpload/FileUpload';
import WYSIWYG from '../../components/WYSIWYG/WYSIWYG';


class SettingsContainer extends Component {
  constructor(props) {
    super(props);
    const { loadDoctorDetails } = this.props;

    loadDoctorDetails(localStorage.getItem('docID'));

    this.toggle = this.toggle.bind(this);
    this.deletePhoto = this.deletePhoto.bind(this);
    this.handleEditorChange = this.handleEditorChange.bind(this);
    this.uploadPhotos = this.uploadPhotos.bind(this);
    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
    this.handleSettingsSubmit = this.handleSettingsSubmit.bind(this);
    this.handleLicenseSubmit = this.handleLicenseSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      activeTab: '1',
      dataLoaded: false,
      settings: {
        name: '',
        homepage: '',
        phone: '',
        email: '',
        fax: '',
        desheadline: '',
        longdes: '',
        lat: '',
        lng: '',
        street: '',
        housenumber: '',
        city: '',
        plz: '',
        openinghours: '',
        license: '',
        oldPwd: '',
        newPwd1: '',
        newPwd2: '',
        profilepic: '',
        images: [],
      }
    };
  }

  static getDerivedStateFromProps(props, current_state) {
    if (current_state.dataLoaded === false && props.currentResult.name && current_state.settings !== props.currentResult) {
      return {
        settings: props.currentResult,
        dataLoaded: true,
      }
    }
    return null
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  componentDidMount() {
    const { loadUserData } = this.props;

    loadUserData();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const {settings} = this.state;

    this.setState({
      settings: {
        ...settings,
        [name]: value
      }
    });
  }

  handleLicenseSubmit(e) {
    const {updateLicense} = this.props;

    updateLicense({lizenz: this.state.settings.license});

    e.preventDefault();
  }

  handlePasswordSubmit(e) {
    const {updatePassword} = this.props;

    updatePassword({oldPwd: this.state.settings.oldPwd, newPwd: this.state.settings.newPwd1});

    e.preventDefault();
  }

  handleSettingsSubmit(e) {
    const {updateProfile} = this.props;

    e.preventDefault();

    const formData = new FormData(e.target);

    console.log(this.state);

    formData.append('longdes', this.state.settings.longdes);
    formData.append('openinghours', this.state.settings.openinghours);

    const files = Array.from(e.target.fotos.files);
    if (e.target.logo) {
      const logo = e.target.logo.files[0];
      formData.append('profielpic', logo);
    }

    files.forEach((file, i) => {
      formData.append(`pic${i + 1}`, file, file.name);
    });

    updateProfile(formData);
  }

  handleEditorChange(name, value) {
    const {settings} = this.state;

    this.setState({
      settings: {
        ...settings,
        [name]: value
      }
    });
  }

  deletePhoto(key, image, multiple = false) {
    const {settings} = this.state;
    let images = settings[key];

    if(multiple) {
      images = images.filter(item => item !== image);
    } else {
      images = null;
    }

    this.setState({
      settings: {
        ...settings,
        [key]: images,
      }
    })
  }

  uploadPhotos(e) {
    const files = Array.from(e.target.files);

    const formData = new FormData();

    files.forEach((file, i) => {
      formData.append(i, file)
    });
  }

  render() {
    const {
      settings
    } = this.state;

    return (
      <div className={'main-wrapper'}>
        <Content>
          <Container>
            <Headline pageTitle>
              Einstellungen
            </Headline>
            <hr />

            <div className={styles.tabWrapper}>
              <Nav tabs className={styles.navWrapper}>
                <NavItem>
                  <NavLink
                    className={classnames(this.state.activeTab === '1' ? [styles.activeTab, 'active'] : null)}
                    onClick={() => {
                      this.toggle('1');
                    }}
                  >
                    Profil
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames(this.state.activeTab === '2' ? [styles.activeTab, 'active'] : null)}
                    onClick={() => {
                      this.toggle('2');
                    }}
                  >
                    Lizenz
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames(this.state.activeTab === '3' ? [styles.activeTab, 'active'] : null)}
                    onClick={() => {
                      this.toggle('3');
                    }}
                  >
                    Passwort
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent className={styles.tabContentWrapper} activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <Headline medium>Persönliche Daten</Headline>

                      <form className={styles.form} onSubmit={this.handleSettingsSubmit}>

                        <Row>
                          <Col xs={12}>
                            <label>Name</label>
                            <Input
                              type="text"
                              name="name"
                              autocomplete="off"
                              value={settings.name}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} sm={6}>
                            <label>Homepage</label>
                            <Input
                              type="text"
                              name="homepage"
                              autocomplete="off"
                              value={settings.homepage}
                              onChange={this.handleInputChange}
                            />
                          </Col>

                          <Col xs={12} sm={6}>
                            <label>Telefon</label>
                            <Input
                              type="text"
                              name="phone"
                              autocomplete="off"
                              value={settings.phone}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} sm={6}>
                            <label>E-Mail-Adresse</label>
                            <Input
                              type="text"
                              name="email"
                              autocomplete="off"
                              value={settings.email}
                              onChange={this.handleInputChange}
                            />
                          </Col>

                          <Col xs={12} sm={6}>
                            <label>Fax</label>
                            <Input
                              type="text"
                              name="fax"
                              autocomplete="off"
                              value={settings.fax}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12}>
                            <label>Öffnungszeiten</label>
                            <WYSIWYG
                              value={settings.openinghours ? settings.openinghours : ''}
                              name="openinghours"
                              onChange={this.handleEditorChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12}>
                            <label>Logo</label>
                            <FileUpload
                              image={settings.profilepic}
                              deleteLabel={<FontAwesomeIcon icon={faTrashAlt} size="2x"/>}
                              deleteAction={(image) => {
                                this.deletePhoto('profilepic', image)
                              }}
                              id="logo"
                              uploadAction={this.uploadPhotos}
                            />
                          </Col>
                        </Row>

                        <hr />

                        <Headline medium>Adresse</Headline>

                        <Row>
                          <Col xs={12} sm={8}>
                            <label>Straße</label>
                            <Input
                              type="text"
                              name="street"
                              autocomplete="off"
                              value={settings.street}
                              onChange={this.handleInputChange}
                            />
                          </Col>

                          <Col xs={12} sm={4}>
                            <label>Hausnummer</label>
                            <Input
                              type="text"
                              name="housenumber"
                              autocomplete="off"
                              value={settings.housenumber}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} sm={4}>
                            <label>PLZ</label>
                            <Input
                              type="text"
                              name="plz"
                              autocomplete="off"
                              value={settings.plz}
                              onChange={this.handleInputChange}
                            />
                          </Col>

                          <Col xs={12} sm={8}>
                            <label>Stadt</label>
                            <Input
                              type="text"
                              name="city"
                              autocomplete="off"
                              value={settings.city}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <hr />

                        <Headline medium>Praxis-Beschreibung</Headline>

                        <Row>
                          <Col xs={12}>
                            <label>Überschrift</label>
                            <Input
                              type="text"
                              name="desheadline"
                              autocomplete="off"
                              value={settings.desheadline}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12}>
                            <label>Beschreibung</label>
                            <WYSIWYG
                              value={settings.longdes ? settings.longdes : ''}
                              name="longdes"
                              onChange={this.handleEditorChange}
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12}>
                            <label>Fotos</label>
                            <FileUpload
                              image={settings.images}
                              multiple
                              id="fotos"
                              deleteLabel={<FontAwesomeIcon icon={faTrashAlt} size="2x"/>}
                              deleteAction={(image) => {
                                this.deletePhoto('images', image, true)
                              }}
                              uploadAction={this.uploadPhotos}
                            />
                          </Col>
                        </Row>

                        <hr />

                        <Headline medium>Google-Maps</Headline>

                        <Row>
                          <Col xs={12} sm={6}>
                            <label>Latitude</label>
                            <Input
                              type="text"
                              name="lat"
                              autocomplete="off"
                              value={settings.lat}
                              onChange={this.handleInputChange}
                            />
                          </Col>

                          <Col xs={12} sm={6}>
                            <label>Longitude</label>
                            <Input
                              type="text"
                              name="lng"
                              autocomplete="off"
                              value={settings.lng}
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Row>

                        <Button submit pullRight>Daten speichern</Button>

                      </form>


                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">

                  <form className={styles.form} onSubmit={this.handleLicenseSubmit}>

                    <Row>
                      <Col xs={12}>
                        <label>Lizenznummer</label>
                        <Input
                          type="text"
                          name="license"
                          autocomplete="off"
                          value={settings.license}
                          onChange={this.handleInputChange}
                        />
                      </Col>
                    </Row>

                    <Button submit pullRight>Daten speichern</Button>

                  </form>

                </TabPane>

                <TabPane tabId="3">

                  <form className={styles.form} onSubmit={this.handlePasswordSubmit}>

                    <Row>
                      <Col xs={12} sm={6}>
                        <label>Altes Passwort</label>
                        <Input
                          type="password"
                          name="oldPwd"
                          autocomplete="off"
                          value={settings.oldPwd}
                          onChange={this.handleInputChange}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={6}>
                        <label>Neues Passwort</label>
                        <Input
                          type="password"
                          name="newPwd1"
                          autocomplete="off"
                          value={settings.newPwd1}
                          onChange={this.handleInputChange}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={6}>
                        <label>Neues Passwort wiederholen</label>
                        <Input
                          type="password"
                          name="newPwd2"
                          autocomplete="off"
                          value={settings.newPwd2}
                          onChange={this.handleInputChange}
                        />
                      </Col>
                    </Row>

                    <Button submit pullRight>Daten speichern</Button>

                  </form>

                </TabPane>
              </TabContent>
            </div>

          </Container>
        </Content>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentResult: state.currentResult,
  };
}

export default connect(mapStateToProps, actions)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/container/doctor/SettingsContainer.js